import { get } from 'lodash'

export const getAsArray = (target, prop) => {
  const out = get(target, prop, [])
  return Array.isArray(out) ? out : []
}
